import { esc, modalCloseBtn } from '../ui/modal';
import { t } from '../ui/lang';
/**
 * Screenshot popup for one row of the operations registry — the screen the clicker
 * photographed when the operation did not succeed.
 *
 * Built like the comment popup beside it (clicker-operation-comment-modal.ts) and for the
 * same reason: openModal() owns the single #modal-backdrop, so a second one would destroy
 * the operations window underneath. Same overlay, same dismissal, same stacking; only the
 * body differs — a picture instead of a paragraph.
 *
 * The image is fetched by the route rather than embedded: it is a wallet screen, served
 * only to whoever may read the operation itself, and the browser caches it privately.
 */
export function showOperationScreenshotModal(host, opId, subtitle) {
    host.querySelector('.ops-comment-overlay')?.remove();
    const overlay = document.createElement('div');
    overlay.className = 'ops-comment-overlay';
    overlay.innerHTML = `
        <div class="ops-comment-card ops-shot-card">
            ${modalCloseBtn()}
            <h2 class="modal__title">${t('clickertab.screenshot')}</h2>
            <p class="settings-hint ops-comment-meta">${esc(subtitle)}</p>
            <div class="ops-shot-body">
                <img class="ops-shot-img" alt="${t('clickertab.screenshot')}" src="/api/operations/${opId}/screenshot" />
            </div>
        </div>
    `;
    // A picture that will not load says so in the card, rather than leaving a broken frame.
    overlay.querySelector('.ops-shot-img').addEventListener('error', () => {
        overlay.querySelector('.ops-shot-body').innerHTML =
            `<p class="settings-hint">${t('clickertab.screenshot_missing')}</p>`;
    });
    const onKey = (e) => {
        if (e.key === 'Escape') {
            e.stopPropagation();
            close();
        }
    };
    const close = () => {
        document.removeEventListener('keydown', onKey, true);
        overlay.remove();
    };
    overlay.querySelector('.modal__close').addEventListener('click', close);
    overlay.addEventListener('click', (e) => { if (e.target === overlay)
        close(); });
    document.addEventListener('keydown', onKey, true);
    host.appendChild(overlay);
}
